class ProductWearItWithNosto extends HHBaseElement {
  constructor() {
    super()
    this.version = parseInt(this.dataset.version) || 1
    this.resultId = this.dataset.resultId
    this.$products = []
    this.$placementID = this.dataset.id
    this.sectionHeadline = this.dataset.sectionHeadline
    this.titleRecommended = ''
    this.$container = this.querySelector('.product-wear-it-with__container')
    this.$titleContainer = this.querySelector('.product-wear-it-with__title')

    this.runNosto = this.runNosto.bind(this)
    this._generateList = this._generateList.bind(this)
    this._generateProductCard = this._generateProductCard.bind(this)

    this.isExpanded = false
    this.handleShowMore = this.handleShowMore.bind(this)
    this.showMoreButton = this.querySelector('.show-more-button')
    if (this.showMoreButton) {
      this.showMoreButton.addEventListener('click', this.handleShowMore)
    }
  }

  runNosto() {
    window.__NOSTO_RECOMMENDER__?.getRecommendation().then((response) => {
      if (typeof response.recommendations[this.$placementID] !== 'undefined') {
        this.$products = response.recommendations[
          this.$placementID
        ].products.filter((product) => !product.tags1.includes('free'))
        this.titleRecommended =
          response.recommendations[this.$placementID].title
        this.resultId = response.recommendations[this.$placementID].result_id

        if (this.sectionHeadline && this.$titleContainer) {
          this.$titleContainer.innerHTML = this.sectionHeadline
        } else if (this.titleRecommended && this.$titleContainer) {
          this.$titleContainer.innerHTML = this.titleRecommended
        }
        if (this.$products.length > 0) {
          this.buildBlock()
        } else {
          this.remove()
        }
      } else {
        this.remove()
      }
    })
  }

  buildBlock() {
    const productContainer = this.$container.querySelector('.product-items')
    productContainer.innerHTML = this._generateList()

    if (window.innerWidth < 768 && productContainer.scrollHeight > 200) {
      this.showMoreButton?.classList.remove('tw-hidden')
    }
  }

  handleShowMore() {
    const productContainer = this.$container.querySelector('.product-items')
    const showMoreBackground = this.$container.querySelector('.show-more-background')
    productContainer.style.setProperty('--product-list-max-height', 'none')
    showMoreBackground.classList.add('tw-hidden')
    this.showMoreButton.classList.add('tw-hidden')
    this.isExpanded = true
  }

  _generateList() {
    const productsList = this.$products.map(this._generateProductCard)

    return `${productsList.join('')}`
  }

  _generateProductCard(item, key) {
    const variantId = item?.recommended_sku?.id || item.product_id
    let classList

    if (this.version == 2) {
      classList = "tw-relative"
    } else {
       classList = "product-card-small product-card-medium background-color-light-tan relative"
    }

    return `
      <product-card
        class="${classList}"
        hydrate
        wear-it-with-nosto
        data-id="${variantId}"
        product-handle="${item.url.split('/').slice(-1)}"
        card-size='medium'
        url-postfix='nosto=${this.resultId}'
      ></product-card>
    `
  }

  connectedCallback() {
    this.runNosto()
    this.addEventListener('click::add-to-cart', (event) => {
      console.log('add to cart', this.resultId, event.detail.product_id)
      window.__NOSTO_RECOMMENDER__?.trackAddToCart(
        event.detail.product_id,
        this.resultId
      )
    })

    this.addEventListener('click::quick-shop-toggle', (event) => {
      console.log('quick-shop-toggle', this.resultId, event.detail.product_id)
      window.__NOSTO_RECOMMENDER__?.trackProductView(
        event.detail.product_id,
        this.resultId
      )
    })
  }
}

window.customElements.define(
  'product-wear-it-with-nosto',
  ProductWearItWithNosto
)
